import type { ConnectionStatus, State } from '../../../../common/types.tsx';

export const getConnectionStatus = ({ connectionStatus }: State): ConnectionStatus => connectionStatus;
